import Box from '@mui/material/Box';
import { RHFSwitchField } from '@openx/components-core/lib/SwitchField/RHFSwitchField.tsx';
import { type ChangeEvent, useCallback } from 'react';
import { type FieldArrayWithId, type Path, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { AudienceShares } from '../../types.ts';

type EnabledFeeSwitchProps = {
  itemIndex: number;
  field: FieldArrayWithId<AudienceShares, 'audience_share', 'id'>;
};

export const EnabledFeeSwitch = ({ itemIndex, field }: EnabledFeeSwitchProps) => {
  const { t } = useTranslation();
  const { setValue, trigger } = useFormContext<AudienceShares>();

  const switchName = `audience_share.${itemIndex}.isFeeEnabled` satisfies Path<AudienceShares>;

  const handleSwitchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      event.preventDefault();
      setValue(switchName, !field.isFeeEnabled, { shouldDirty: true, shouldTouch: true });
      field.isFeeEnabled = !field.isFeeEnabled;

      if (field.isFeeEnabled === false) {
        trigger(`audience_share.${itemIndex}.value` satisfies Path<AudienceShares>);
      }
    },
    [field, itemIndex, setValue, switchName, trigger]
  );

  return (
    <Box sx={{ mt: 2 }}>
      <RHFSwitchField
        data-test="enable-fee-switch"
        label={t('Enable setting fee for shared audience(s)')}
        name={switchName}
        onChange={handleSwitchChange}
      />
    </Box>
  );
};
